import React from 'react'
import Action from '../primitives/Action'
import styles from './AudioAction.module.scss'

const AudioAction = ({
  className = '',
  href,
  mode = 'primary',
  size = 'standard',
  fullWidth = false,
  ...props
}) => {
  const external = props.external
    ?? /^(?:https?:|tel:|mailto:)/.test(String(href || ''))
  const primitiveVariant = ['primary', 'secondary', 'heroPrimary'].includes(mode)
    ? 'control'
    : 'plain'

  return (
    <Action
      {...props}
      href={href}
      external={external}
      size={size}
      variant={primitiveVariant}
      className={`${styles.action} ${styles[mode] || ''} ${styles[size] || ''} ${fullWidth ? styles.fullWidth : ''} ${className}`.trim()}
    />
  )
}

export default AudioAction
